<template>
<div>
    <b-navbar :fixed-top=true>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <figure class="image is-32x32" >
                    <img    src="@/assets/KU_SubLogo.png" alt="Image">
                </figure>



                <h2 > VET KU </h2>
                &nbsp;
                <h3 >laboratory</h3>
            </b-navbar-item>
            &nbsp;&nbsp;&nbsp;
        </template>
        <template slot="start">
            <b-navbar-item >
                <router-link to="/" >Home</router-link> 
            </b-navbar-item>
<!--            <b-navbar-item >-->
<!--                <router-link to="/dashboard" >Dashboard</router-link> -->
<!--            </b-navbar-item>-->
<!--            <b-navbar-item v-if="!isMobile" >-->
             <b-navbar-item v-if="!isMobile"  >
                <router-link to="/worklist" >Worklist</router-link> 
            </b-navbar-item>
<!--            <b-navbar-item v-if="isMobile" >-->

            <b-navbar-item  v-if="isMobile" >
                <router-link to="/opdspaceformobile" >OPD Space Zone</router-link>
            </b-navbar-item>





<!--            <b-navbar-item >-->
<!--                <figure class="image is-24x24">-->
<!--                    <img class="is-rounded" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/331810/profile-sample5.jpg">-->
<!--                </figure>-->
<!--            </b-navbar-item>-->

            <b-navbar-dropdown label="User Customize" hoverable  >
                <!-- <b-navbar-item href="#" @click.native="manageCBCCustomize1">
                    <b-icon
                            icon="square-edit-outline"
                            size="is-small"
                            class="mr-3"
                            >
                    </b-icon> &nbsp; CBC Customize Table
                </b-navbar-item> -->
                <b-navbar-item  href="#"   @click.native="showUserRole">
                    <b-icon
                            icon="account-box-outline"
                            size="is-small"
                            class="mr-3"
                            >
                    </b-icon> &nbsp;
                     View Your Role
                </b-navbar-item>
                <b-navbar-item  href="#"   @click.native="showMytemplateManagement">
                    <b-icon
                            icon="file-document"
                            size="is-small"
                            class="mr-3"
                            >
                    </b-icon> &nbsp;
                    My template
                </b-navbar-item>

<!--                <b-navbar-item href="#"  v-if="user_id === 1"  @click.native="BlogDisplay" >-->
<!--                    My Blogs-->
<!--                </b-navbar-item>-->
            </b-navbar-dropdown>


<!-- ************************************************************************************   -->
    <b-navbar-dropdown label="Services" hoverable  >
            <b-navbar-item href="#" @click.native="patholistofjobservices">
                    <b-icon
                            icon="monitor-dashboard"
                            size="is-small"
                            class="mr-3"
                            >
                    </b-icon>  Pathology Job Services
            </b-navbar-item>


            <b-navbar-item href="#" @click.native="pathomemberdashboard">
                    <b-icon
                            icon="store"
                            size="is-small"
                            class="mr-3"
                            >
                    </b-icon> LAB Member Manager
            </b-navbar-item>


            <b-navbar-item href="#" @click.native="pathoinvoicemanager">
                    <b-icon
                            icon="text-box-outline"
                            size="is-small"
                            class="mr-3"
                            >
                    </b-icon> Pathology Invoice Manager
            </b-navbar-item>

          


    </b-navbar-dropdown>
            
<!-- ************************************************************************************** -->
             <!-- <b-navbar-dropdown label="Manual Lab Automate" hoverable  >
                <b-navbar-item href="#" >
                    <router-link to="/create_lab_automate" >Create Lab Automate</router-link> 
                </b-navbar-item>
                <b-navbar-item  href="#" >
                    <router-link to="/create_lab_automate_v2"  >Create Lab Automate V2</router-link>  
                </b-navbar-item>

                 <b-navbar-item  href="#"   @click.native="create_lab_automate_v2">
                   Create Lab Automate V2
                </b-navbar-item>
            </b-navbar-dropdown> -->






<!-- ************************************************************************************** -->
             <!-- <b-navbar-item   >
                <router-link to="/imagesofmonth" >Pathology Images</router-link> 
            </b-navbar-item> -->

            
      
<!-- ************************************************************************************** -->

            <b-navbar-item v-if="!isMobile && userIsAdmin"   >
                <router-link to="/admin" >Admin</router-link> 
            </b-navbar-item>


            <!-- <b-navbar-dropdown label="Admin" hoverable  v-if="userIsAdmin" >
                <b-navbar-item href="#" @click.native="userManagement" v-if="userIsAdmin">
                    User Management
                </b-navbar-item>

                <b-navbar-item href="#" @click.native="authGroup" v-if="userIsAdmin">
                    Auth. Group
                </b-navbar-item>

                <b-navbar-item href="#" @click.native="authGrant" v-if="userIsAdmin">
                    Auth. Grant
                </b-navbar-item>
                <hr>
                <b-navbar-item href="#" @click.native="nonAutomateCombosetManagement" v-if="userIsAdmin">
                    NonAutomate Comboset Management(For VR)
                </b-navbar-item>


                <b-navbar-item href="#" @click.native="warningWhenLabUnpublish" v-if="userIsAdmin">
                    Warning When Lab Unpublish
                </b-navbar-item>
                <hr>

                <b-navbar-item href="#" @click.native="disableReasonManagement" v-if="userIsAdmin">
                    Disable Reason Management
                </b-navbar-item>

                <b-navbar-item href="#" @click.native="disableReport" v-if="userIsAdmin">
                    Disable Report
                </b-navbar-item>

                <hr>

                <b-navbar-item href="#" @click.native="deleteOrderReasonManagement" v-if="userIsAdmin">
                    DeleteOrder Reason Management
                </b-navbar-item>



                <hr>



 
                <b-navbar-item href="#" @click.native="showWebLog" v-if="userIsAdmin">
                    Web Log
                </b-navbar-item>

                <hr>

                <b-navbar-item href="#" @click.native="showResultPCRMange" v-if="userIsAdmin">
                   Result PCR Management
                </b-navbar-item>


                <b-navbar-item href="#" @click.native="showDxCodeManage" v-if="userIsAdmin">
                    Dx Code Management
                </b-navbar-item>


                <b-navbar-item href="#" @click.native="showDashboardLabNonStatus" v-if="userIsAdmin">
                    Dashboard Status Lab Non Automate
                </b-navbar-item>
                <hr>

                <b-navbar-item href="#" @click.native="showBactDataMst" v-if="userIsAdmin">
                    Bacterial Data Master
                </b-navbar-item>


                <b-navbar-item href="#" @click.native="showOrgaDataMst" v-if="userIsAdmin">
                    Orga Data Master
                </b-navbar-item>


                <hr>
                <b-navbar-item href="#" @click.native="showReportA01" v-if="userIsAdmin">
                    ReportA01 (rec , paid , unpaid , disable)
                </b-navbar-item>

                <b-navbar-item href="#" @click.native="showReportA02" v-if="userIsAdmin">
                    ReportA02 (count image/scan with department(column) with dvm(row) )
                </b-navbar-item>

                <b-navbar-item href="#" @click.native="showReportA03" v-if="userIsAdmin">
                    ReportA03 (count image/scan with document(column) with dvm(row) )
                </b-navbar-item>


                <b-navbar-item href="#" @click.native="showReportB01" v-if="userIsAdmin">
                    ReportB01 (List of used item for LAB Automate)
                </b-navbar-item>

               <b-navbar-item href="#" @click.native="showReportI01" v-if="userIsAdmin">
                    ReportI01 (Stock or Inventory I)
               </b-navbar-item>

               <b-navbar-item href="#" @click.native="showReportI02" v-if="userIsAdmin">
                    ReportI02 (Stock or Inventory II)
               </b-navbar-item>


            </b-navbar-dropdown> -->

<!-- ************************************************************************************** -->


        </template>

        <template slot="end">


            <b-navbar-item tag="div">
            <figure class="image is-32x32" v-if="avartar">
                <img  class="is-rounded"  :src="avartar" alt="Image">
            </figure> &nbsp; Login By &nbsp;

                <span class="tag "  style="color: teal">{{user_full_name_surname}} </span>
<!--                <b-button  pack="fas" icon-left="tray" type="is-primary" size="is-small" outlined> 12 </b-button>-->



            </b-navbar-item>




            <b-navbar-item tag="div">

                <div class="buttons">
                    <a class="button is-info" @click="doLogout">
                        Log out
                    </a>
                </div>
            </b-navbar-item>
        </template>
        
    </b-navbar>

    <div id="underline">
        
    </div>

    <DlgManageCBCCustomize   ref="DlgManageCBCCustomize"  />
    <!-- <UserManagement   v-if="isUserManagement" :isComponentModalActive="isUserManagement" @closeUserManagement="closeUserManagement"/> -->
    <Blog ref="Blog" />
    <BlogTmce ref="BlogTmce"  />
    <!-- <AuthGroup ref="AuthGroup"/> -->
    <!-- <AuthGrant ref="AuthGrant"/> -->
    <ShowUserRole  v-if="isModalShowUserRole"   @close="closeModalShowUserRole" />
    <ManageMyTemplate  ref="ManageMyTemplate" @close="closeModalManageMyTemplate" />
    <!-- <GroupNonAutomateReqManagement ref="GroupNonAutomateReqManagement"/> -->
    <SpecimensManagement ref="SpecimensManagement"/>
    <!-- <WebLog ref="WebLog" @closeModalWebLog="closeModalWebLog" /> -->
    <!-- <ReportA001  ref="ReportA001"    /> -->
    <!-- <ReportA002  ref="ReportA002" /> -->
    <!-- <ReportA003  v-if="isReportA003Show" :isReportShow="isReportA003Show" @closeReportA003="closeReportA003"/> -->
    <!-- <WarningLabUnPublish ref="WarningLabUnPublish" /> -->
    <!-- <DisableReasonManagement ref="DisableReasonManagement" /> -->
    <!-- <ReportDisabled   ref="ReportDisabled"/> -->
    <!-- <DeleteOrderReasonManagement ref="DeleteOrderReasonManagement"/> -->
<!-- ref="UserManagement"-->
<!--    <ResultPCRManageDashboard-->
<!--            v-if="isResultPCRManageShowing"-->
<!--            :isComponentModalActive = "isResultPCRManageShowing"-->
<!--            @close="closeResultPCRMange"-->
<!--    />-->
    <!-- <PCRPathogenDashboard
            v-if="isResultPCRManageShowing"
            :isComponentModalActive = "isResultPCRManageShowing"
            @close="closeResultPCRMange"
    /> -->


    <DxCodeManagement
            v-if="isDxCodeManageShowing"
            :isComponentModalActive = "isDxCodeManageShowing"
            @close="closeDxCodeManagement"
    />


    <DashboardLabNonStatus
            v-if="isDashboardLabNonStatusShowing"
            :isComponentModalActive = "isDashboardLabNonStatusShowing"
            @close = "closeDashboardLabNonStatus"
    />


    <BactDataMst
            v-if="isBactDataMstShowing"
            :isComponentModalActive = "isBactDataMstShowing"
            @closeBactDataMst = "closeBactDataMst"
    />


    <OrgaDataMst
            v-if="isOrgaDataMstShowing"
            :isComponentModalActive = "isOrgaDataMstShowing"
            @closeOrgaDataMst = "closeOrgaDataMst"
    />


    <ReportB01
            v-if="isReportB01Showing"
            :isComponentModalActive = "isReportB01Showing"
            @close = "closeReportB01"
    />
    
    <ReportI01
            v-if="isReportI01Showing"
            :isComponentModalActive = "isReportI01Showing"
            @close = "closeReportI01"
    />



    <!-- <ReportI02
            v-if="isReportI02Showing"
            :isComponentModalActive = "isReportI02Showing"
            @close = "closeReportI02"
    /> -->

    <b-modal
                v-if="isReportI02Showing"
                v-model="isReportI02Showing"
                has-modal-card
                full-screen
        >

            <ReportI02
                    v-if="isReportI02Showing"
                    :isComponentModalActive ="isReportI02Showing"
                    @close = "closeReportI02"
                    
            />
        </b-modal>





        <b-modal
                v-if="isShowManuallyCreateLabAutomateV2"
                v-model="isShowManuallyCreateLabAutomateV2"
                has-modal-card
                full-screen
               >
            <ManuallyCreateLabAutomateV2
                    v-if="isShowManuallyCreateLabAutomateV2"
                    :isComponentModalActive = "isShowManuallyCreateLabAutomateV2"
                    @close="closeManuallyCreateLabAutomateV2"
            />
        </b-modal>






</div>    
</template>



<script>
    /* eslint-disable no-console */
import DlgManageCBCCustomize from "./Users/DlgManageCBCCustomize";
// import UserManagement from "./Users/UserManagement";
// import AuthGroup from "./Users/AuthGroup";
// import AuthGrant from "./Users/AuthGrant";
import axios from "axios"
import {logout ,removeLocalStorage } from "../utils";
import {mapState,mapActions, mapMutations} from "vuex";
import Blog from "./Users/Blog";
import BlogTmce from "./Users/BlogTmce";
import mobile  from 'is-mobile'
import ShowUserRole from "./Users/ShowUserRole";
import ManageMyTemplate from "./Users/Teamplate/ManageMyTemplate";
// import GroupNonAutomateReqManagement from "./Admin/GroupNonAutomateReqManagement";
import SpecimensManagement from "./Admin/Specimens/SpecimensManagement";
// import WebLog from "./Admin/WebLog";
// import ReportA001 from "./Admin/Reports/ReportA001";
// import ReportA002 from "./Admin/Reports/ReportA002";
// import ReportA003 from "./Admin/Reports/ReportA003";
// import WarningLabUnPublish from "./Admin/WarningLabUnPublish/WarningLabUnPublish";
// import DisableReasonManagement from "./Admin/DisableReason/DisableReasonManagement";
// import ReportDisabled from "./Admin/Reports/ReportDisabled";
// import DeleteOrderReasonManagement from "./Admin/DeleteOrderReason/DeleteOrderReasonManagement";
// import ResultPCRManageDashboard from "./Admin/PCR/ResultPCRManageDashboard";
// import PCRPathogenDashboard from "./Admin/PCR/PCRPathogenDashboard";
import DxCodeManagement from "./Admin/DxCode/DxCodeManagement";
import DashboardLabNonStatus from "./Admin/DashboardLabNonStatus/DashboardLabNonStatus";
import BactDataMst from "./Admin/Bact/BactDataMst";
import OrgaDataMst from "./Admin/Orga/OrgaDataMst";
import ReportB01 from "./Admin/Reports/ReportB01";
import ReportI01 from './Admin/Reports/ReportI001.vue'
import ReportI02 from './Admin/Reports/ReportI002.vue'



import ManuallyCreateLabAutomateV2 from '../components/LABAutomate/ManuallyCreateLabAutomate/ManuallyCreateLabAutomateV2.vue'


export default {
    name : 'Header',
    components:{
        DlgManageCBCCustomize,
        // UserManagement ,
        // AuthGroup,
        // AuthGrant,
        Blog,
        BlogTmce,
        ShowUserRole,
        ManageMyTemplate,
        // GroupNonAutomateReqManagement,
        SpecimensManagement,
        // WebLog,
        // ReportA001,
        // ReportA002,
        // ReportA003,
        ReportB01,
        ReportI01,
        ReportI02,
        // WarningLabUnPublish,
        // DisableReasonManagement,
        // ReportDisabled,
        // DeleteOrderReasonManagement,
        // PCRPathogenDashboard,
        DxCodeManagement,
        DashboardLabNonStatus,
        BactDataMst,
        OrgaDataMst,

        // ResultPCRManageDashboard

        ManuallyCreateLabAutomateV2,
    },
    data(){
        return {
            isMobile : mobile(),
            isModalShowUserRole : false,
            isModalManageMyTemplate : false,
            isReportA003Show : false,
            //
            isResultPCRManageShowing : false,

            isDxCodeManageShowing : false,

            isDashboardLabNonStatusShowing : false,
            isBactDataMstShowing : false,
            isOrgaDataMstShowing : false,


            isUserManagement : false ,
            isReportB01Showing : false,
            isReportI01Showing : false,
            isReportI02Showing : false,


            isShowManuallyCreateLabAutomateV2 : false,
        }
    },

    computed:{
         ...mapState({
                fingerPrint : state => state.master_data.fingerPrint,
                avartar : state => state.master_data.avartar,
                userIsAdmin: state => state.master_data.userIsAdmin,
                user_id : state => state.master_data.user_id,
                user_full_name_surname : state => state.master_data.user_full_name_surname,

                 

            })
         ,
          getNameAndSurname(){
            return localStorage.getItem('user_name_surname')
        },

    },
    methods: {
        ...mapActions({
            clearListOfCytoResultRecently : 'home/clearListOfCytoResultRecently'
        }),
        ...mapMutations({
            setModeManuallyLabAutomate : 'manually_create_lab_automate/setModeManuallyLabAutomate'
        }),

        closeManuallyCreateLabAutomateV2(){
            this.isShowManuallyCreateLabAutomateV2 = false 
          
        },
        create_lab_automate_v2(){
            // set mode
             this.setModeManuallyLabAutomate(0) // 0 == new insert , 1 == edit 
                                                // right now stand for new insert
                                                
            this.isShowManuallyCreateLabAutomateV2 = true
            //  // set mode
            //   0 this.setModeManuallyLabAutomate(0) // 0 == new insert , 1 == edit 
            //                                     // right now stand for new insert
            //  this.$router.push(`/create_lab_automate_v2`)
            //             .catch(()=>{});
        },

        create_lab_automate(){
             // set mode
             this.setModeManuallyLabAutomate(0) // 0 == new insert , 1 == edit 
                                                // right now stand for new insert
             this.$router.push(`/create_lab_automate`)
                        .catch(()=>{});
        },
        pathoinvoicemanager(){
             this.$router.push(`/pathoinvoicemanager`)
                        .catch(()=>{});
        },

        pathomemberdashboard(){
            this.$router.push(`/pathomemberdashboard`)
                        .catch(()=>{});
        },
        
        patholistofjobservices(){
            this.$router.push(`/patholistofjobservices`)
                        .catch(()=>{});
        }, 
    
        showReportI02(){
            this.isReportI02Showing = true
        },
        closeReportI02(){
            this.isReportI02Showing = false
        },



        showReportI01(){
            this.isReportI01Showing = true
        },
        closeReportI01(){
            this.isReportI01Showing = false
        },


        showReportB01(){
            this.isReportB01Showing = true
        },
        closeReportB01(){
            this.isReportB01Showing = false
        },
        closeUserManagement(){
            this.isUserManagement = false
        },
        closeOrgaDataMst(){
            this.isOrgaDataMstShowing = false
        },
        showOrgaDataMst(){
            this.isOrgaDataMstShowing = true
        },
        closeBactDataMst(){
            this.isBactDataMstShowing = false
        },
        showBactDataMst(){
            this.isBactDataMstShowing = true
        },
        closeDashboardLabNonStatus(){
            this.isDashboardLabNonStatusShowing = false
        },
        showDashboardLabNonStatus(){
            this.isDashboardLabNonStatusShowing = true
        },
        closeDxCodeManagement(){
            this.isDxCodeManageShowing  = false
        },
        showDxCodeManage(){
            this.isDxCodeManageShowing  = true
        },
        closeResultPCRMange(){
            this.isResultPCRManageShowing = false
        },
        showResultPCRMange(){
            this.isResultPCRManageShowing = true

        },
        // disableReport(){
        //     this.$refs.ReportDisabled.loadCurrentDate(2)
        //     this.$refs.ReportDisabled.isComponentModalActive = true
        // },
        closeReportA003(){
            this.isReportA003Show = false
        },
        showReportA03(){
            this.isReportA003Show = true
        },
        showReportA02(){
            this.$refs.ReportA002.isComponentModalActive = true
        },
        showReportA01(){
            this.$refs.ReportA001.isComponentModalActive = true
        },
        // warningWhenLabUnpublish(){
        //     this.$refs.WarningLabUnPublish.init()
        //     this.$refs.WarningLabUnPublish.isComponentModalActive = true
        // },
        // deleteOrderReasonManagement(){
        //     this.$refs.DeleteOrderReasonManagement.loadData()
        //     this.$refs.DeleteOrderReasonManagement.isComponentModalActive = true
        // },
        // disableReasonManagement(){
        //     this.$refs.DisableReasonManagement.loadData()
        //     this.$refs.DisableReasonManagement.isComponentModalActive = true
        // },
        // showWebLog(){
        //     this.$refs.WebLog.loadCurrentDate()
        //     this.$refs.WebLog.isComponentModalActive = true
        // },
        // closeModalWebLog(){
        //     this.$refs.WebLog.isComponentModalActive = false
        // },
        speciemensManagement(){
            this.$refs.SpecimensManagement.doFetchSpecimenType()
            this.$refs.SpecimensManagement.isComponentModalActive = true
        },
        // nonAutomateCombosetManagement(){
        //     this.$refs.GroupNonAutomateReqManagement.doFetchGroupNonautomateRequest()
        //     this.$refs.GroupNonAutomateReqManagement.isComponentModalActive = true
        // },
        closeModalManageMyTemplate(){
            this.isModalManageMyTemplate = false
        },
        closeModalShowUserRole(){
            this.isModalShowUserRole = false
        },
        showMytemplateManagement(){
            this.$refs.ManageMyTemplate.loadMytemplate()
            this.$refs.ManageMyTemplate.isComponentModalActive = true
        },
        showUserRole(){
            this.isModalShowUserRole = true
        },
        // authGrant(){
        //     this.$refs.AuthGrant.isComponentModalActive = true
        // },
        // authGroup(){
        //     this.$refs.AuthGroup.isComponentModalActive = true
        // },
        BlogDisplay(){
             // this.$refs.BlogTmce.isComponentModalActive = true
            this.$refs.Blog.isComponentModalActive = true
        },
        manageCBCCustomize1() {
            this.$refs.DlgManageCBCCustomize.isComponentModalActive = true
        },
        userManagement() {
            // this.$refs.UserManagement.isComponentModalActive = true
            this.isUserManagement = true
        },
        doLogout() {
            this.$store.commit('home/resetRecentImages')
            this.$store.commit('mytemplateTxt/resetCache')
            // delete access token
            this.clearListOfCytoResultRecently()
            removeLocalStorage()
            logout(this.fingerPrint)
            axios.defaults.headers.common['Authorization'] = null
            this.$router.go()
            // this.$router.push('/login')
            //     .catch(()=>{});

        }
    }
}
</script>

<style scoped>
  #underline{
      background-color: rgb(86, 126, 144);
      height: 1px;
  }
</style>